import React, { useState, useEffect ,useRef} from 'react';
import NavigationBar from '../../ReusableComp/NavigationBar';
import NavBarLeft from '../../ReusableComp/NavBarLeft';
import { useDispatch, useSelector } from 'react-redux';
import { getZoneData, getCityData, getStateData, getSiteData, getStudyData } from '../../../Redux/actions/actions';
import axios from "../../../axios-interceptor";
import { base_url } from "../../../utilities";
import PopUpModal from "../../ReusableComp/PopUpModal";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import { useNavigate } from 'react-router';
import Loader from '../../ReusableComp/Loader';


const PMSAdminAddPI = () => {
    const navigate = useNavigate();
    useEffect(() => {
        if (!localStorage.getItem("login_user_name")) {
            navigate("/");
        }
    }, [navigate]);
    const dispatch = useDispatch();

    const [piName, setPiName] = useState('');
    const [piContactNumber, setPiContactNumber] = useState('');
    const [piEmail, setPiEmail] = useState('');
    const [piGender, setPiGender] = useState('');
    const [piAddressLane1, setPiAddressLane1] = useState('');
    const [piCountry, setPiCountry] = useState('India');
    const [piState, setPiState] = useState('');
    const [piDistrict, setPiDistrict] = useState('');
    const [piCity, setPiCity] = useState('');
    const [piPincode, setPiPincode] = useState('');
    const [piNationality, setPiNationality] = useState('Indian');
    const [piAadhar, setPiAadhar] = useState('');
    const [piIdType, setPiIdType] = useState('');
    const [piIdNumber, setPiIdNumber] = useState('');
    const [piOtherEmail, setPiOtherEmail] = useState('');
    const [piMciNumber, setPiMciNumber] = useState('');
    const [piNMciDate, setPiNMciDate] = useState('');
    const [open, setOpen] = React.useState(false);
    const zoneData = useSelector((state) => state.data);
    const stateData = useSelector((state) => state.stateData);
    const cityData = useSelector((state) => (state.cityData));
    const siteData = useSelector((state) => (state.siteData));
    const studyData = useSelector((state) => (state.studyData))

    const [siteCode, setSiteCode] = useState('');
    const [zone, setZone] = useState('');

    const [stateSelected, setStateSelected] = useState('');

    const [city, setCity] = useState('');

    const [site, setSite] = useState('');

    const [phoneSatisfied, setPhoneSatisfied] = useState(false);
    const [pincodeSatisfied, setPincodeSatisfied] = useState(false);
    const [aadharSatisfied, setAadharSatisfied] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [zoneName, setZoneName] = useState("")
    const [stateName, setStateName] = useState("")
    const [cityName, setCityName] = useState("");
    const [siteName, setSiteName] = useState("");
    const [studyIds, setStudyIds] = useState([]);
    const [diable, setisDoneDisble] = useState(false);
    const [loading, setLoading] = useState(false);
    const [siteAddress, setSiteAddress] = useState("");
    
    const [cityArray, setCityArray] = useState();


    useEffect(() => {
        dispatch(getZoneData());
        dispatch(getStudyData());
    }, [dispatch]);
    const sampar = [];


    const handleChange = (selected) => {
        selected.map((item) => { sampar.push(item.value.study_id) })
        setSelectedOptions(selected);
        setStudyIds(sampar);
    };


    const handleClosePopup = () => {
        setOpen(false);
        navigate('/pilist')
        window.location.reload();
        
    };
    const [resume, setResume] = useState("");
    const [resumeName, setResumeName] = useState(null);

//  const handleChangeFileUpload = (event) => {
//         if ((event.target.files[0].name.substring(event.target.files[0].name.lastIndexOf('.')) == ".jpg") ||
//             (event.target.files[0].name.substring(event.target.files[0].name.lastIndexOf('.')) == ".jpeg") ||
//             (event.target.files[0].name.substring(event.target.files[0].name.lastIndexOf('.')) == ".png") ||
//             (event.target.files[0].name.substring(event.target.files[0].name.lastIndexOf('.')) == ".pdf")||
//             (event.target.files[0].name.substring(event.target.files[0].name.lastIndexOf('.')) == ".doc")) {
           
//            if (event.target.files[0].size < 20971520) {
//             setResume(event.target.files[0]);
//             setResumeName(event.target.files[0].name);
//         } else {
//             toast.error("File size should be less than 20 MB", {
//                 toastId: 7,
//             });
//         }
//         }
//         else {
//             toast.error("Please upload a valid images .pdf / .jpeg / .jpg /.doc", {
//                 toastId: 7,
//             });
//         }
//     }
const handleChangeFileUpload = (event) => {
    const allowedFileExtensions = ['.jpg', '.jpeg', '.png', '.pdf', '.doc','.docx'];

    if (allowedFileExtensions.includes(event.target.files[0].name.substring(event.target.files[0].name.lastIndexOf('.')))) {
      if (event.target.files[0].size < 20971520) {
        setResume(event.target.files[0]);
        setResumeName(event.target.files[0].name);
      } else {
        toast.error("File size should be less than 20 MB", {
          toastId: 7,
        });
      }
    } else {
      toast.error("Please upload a valid image, PDF, or Word document (.pdf / .jpeg / .jpg /.doc)", {
        toastId: 7,
        className: 'custom-toast',
      });
    }
  };
  const handleClearFile = () => {
    setResume(null);
    setResumeName('');
    const inputField = document.getElementById('thumbnailimageUpload');
    if (inputField) {
    inputField.value = '';
    }
  };
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };
  const handlePreview = () => {
    // Add logic here to open the uploaded document in the browser preview
    // For example, you can use window.open() to open a new tab with the document URL
    // Make sure to handle different file types (e.g., PDF, image, etc.) accordingly
    if (resume) {
      // Sample logic for PDF preview
      window.open(URL.createObjectURL(resume), '_blank');
    }
  };
    const createNewPI = () => {
        const fd = new FormData();
        let principle_investigator_object = {
            "name": piName,
            "contact_number": Number(piContactNumber),
            "email": piEmail,
            "gender": piGender,
            "address": piAddressLane1,
            "country": piCountry,
            "state": piState,
            "district": piDistrict,
            "city": piCity,
            "pin_code": piPincode,
            "nationality": piNationality,
            "id_proof_type": piIdType,
            "id_proof_details": piIdNumber,
            "aadhar_card_number": piAadhar,
            "mci_registration_number": piMciNumber,
            "mci_registered_date": piNMciDate,
            "other_email": piOtherEmail,
            "zone_id": zone,
            "site_id": site,
            "state_id": stateSelected,
            "city_id": city,
            "study_id": studyIds,
            "created_by": localStorage.getItem('login_user_name')
        };
        for (const key in principle_investigator_object) {
            if (key === 'study_id') {
                fd.append(key, JSON.stringify(principle_investigator_object[key]));
            } else {
                fd.append(key, principle_investigator_object[key]);
            }
        }
        fd.append('file', resume);
        setisDoneDisble(true)
        setLoading(true);
        axios
            .post(base_url + "principal-investigator/create_principal_investigator", fd, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
            )
            .then((res) => {
                    setLoading(false);
                
                if (res.data.data.errors) {
                    if (res.data.data.errors[0].message === "email must be unique") {
                        setisDoneDisble(false)
                        toast.error('The user has already been created with the given email.', {
                            toastId: 1
                        })
                    }
                }
                else {
                    setOpen(true);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };
    const handlePiNameChange = (event) => {
        const inputValue = event.target.value;
        const regex = /^[A-Za-z\s.]+$/; // Only alphabetic characters allowed

        if (regex.test(inputValue) || inputValue === '') {
            setPiName(event.target.value);
        }
    };
    const handlePiContactNumberChange = (e) => {
let value = e.target.value;
setPiContactNumber(value.length>10?value.slice(0,10):value);
        
       
        if (value.length >= 10) {
            setPhoneSatisfied(false);
        }
        else {
            setPhoneSatisfied(true);
        }
    };

    const handlePiEmailChange = (e) => {
        const input = e.target;
        const isValid = input.checkValidity();
        setIsPiEmailValid(isValid);
        setPiEmail(input.value);

    };



    const handlePiGenderChange = (value) => {

        setPiGender(value);
    };

    const handlePiAddressLane1Change = (event) => {
        setPiAddressLane1(event.target.value);
    };

    const handlePiCountryChange = (event) => {
        const inputValue = event.target.value;
        const regex = /^[A-Za-z\s]+$/; // Only alphabetic characters allowed

        if (regex.test(inputValue) || inputValue === '') {
            setPiCountry(event.target.value);
        }
    };

    const handlePiStateChange = (event) => {
        const inputValue = event.target.value;
        const regex = /^[A-Za-z\s]+$/; // Only alphabetic characters allowed

        if (regex.test(inputValue) || inputValue === '') {
            setPiState(event.target.value);
        }
    };

    const handlePiDistrictChange = (event) => {
        const inputValue = event.target.value;
        const regex = /^[A-Za-z\s]+$/; // Only alphabetic characters allowed

        if (regex.test(inputValue) || inputValue === '') {
            setPiDistrict(event.target.value);
        }
    };

    const handlePiCityChange = (event) => {
        const inputValue = event.target.value;
        const regex = /^[A-Za-z\s]+$/; // Only alphabetic characters allowed

        if (regex.test(inputValue) || inputValue === '') {
            setPiCity(event.target.value);
        }
    };
    const handlePiPincodeChange = (e) => {
        let value =e.target.value
        setPiPincode(value.length>6?value.slice(0,6):value)
        
        if (value.length >=6) {
            setPincodeSatisfied(false);
        }
        else {
            setPincodeSatisfied(true);
        }
    };
    const viewProfile = () => {
        navigate("/pilist");
    }

    const handlePiNationalityChange = (event) => {
        const inputValue = event.target.value;
        const regex = /^[A-Za-z\s]+$/; // Only alphabetic characters allowed

        if (regex.test(inputValue) || inputValue === '') {
            setPiNationality(event.target.value);
        }
    };

    const maskedAadhar = piAadhar.slice(0, -4).replace(/\d/g, '*') + piAadhar.slice(-4);
    const handlePiAadharChange = (event) => {
        let { value } = event.target;
        if (value.includes("********")) {
            value = piAadhar.slice(0, 8) + value.replace(/\D/g, '')
        } else {
            value = value;
        }
        const numericValue = value.replace(/\D/g, '');
        if (/^[0-9]+$/.test(numericValue) || numericValue === "") {
            setPiAadhar(numericValue.length>12?numericValue.slice(0,12):numericValue);
            if (numericValue.length === 12) {
                setAadharSatisfied(false);
            } else {

                setAadharSatisfied(true);
            }
        }
    };

    const handlePiIdTypeChange = (event) => {
        setPiIdType(event.target.value);
    };

    const handlePiIdNumberChange = (event) => {
        setPiIdNumber(event.target.value);
    };

    const handlePiOtherEmailChange = (event) => {
        setPiOtherEmail(event.target.value);
    };

    const handlePiMciNumberChange = (event) => {
        setPiMciNumber(event.target.value);
    };

    const handlePiNMciDateChange = (event) => {
        setPiNMciDate(event.target.value);
    };


    const selectZone = (event) => {
        let data =""
        const selectedIndex = event.target.selectedIndex;
        setZone(event.target.value)
        setZoneName(event.target.options[selectedIndex].text)
        setStateSelected("")
        setCity("")
        setSite("")
        setSiteCode("")
        dispatch(getStateData(event.target.value));
        dispatch(getCityData(null));
        dispatch(getSiteData(null));

        
    }

    const selectState = (event) => {
        const selectedIndex = event.target.selectedIndex;
        setStateSelected(event.target.value)
        setStateName(event.target.options[selectedIndex].text)
        setCity("")
        setSite("")
        setSiteCode("")
        dispatch(getCityData(event.target.value));
    }

    const selectCity = (event) => {
        const selectedIndex = event.target.selectedIndex;

        setCity(event.target.value)
        setCityName(event.target.options[selectedIndex].text)
        setSite("")
        setSiteCode("")
        dispatch(getSiteData(event.target.value));
    }

    const selectSite = (event) => {
        const selectedIndex = event.target.selectedIndex;

        setSite(event.target.value)
        setSiteName(event.target.options[selectedIndex].text)
        const val = event.target.value
        if (val === '') {
            setSiteCode('')
            setSiteAddress('')
        }
        else {
            for (let i = 0; i < siteData.length; i++) {
                if (siteData[i].site_id === val) {
                    setSiteCode(siteData[i].site_code)
                    setSiteAddress(siteData[i].site_address)
                }
            }
        }


    }

    const [regStep, setRegStep] = useState(1);

    const registrationSteps = [
        {
            stepTitle: "1. Principal Investigator Details",
            description: "Age, Sex, Phone etc."
        },
        {
            stepTitle: "2. Study Details",
            description: "Hospital and Dose Information"
        },
        {
            stepTitle: "3. Site Information",
            description: "Hospital, Phone etc.."
        },
        {
            stepTitle: "4. Preview and Confirm",
            description: "Final confirmation"
        },

    ];

    const handleStepChange = (val) => {
        if (val > 0 && regStep < 4) {
            let shift = regStep + val
            setRegStep(shift);
        }
        if (val < 0 && regStep > 1) {
            let shift = regStep + val
            setRegStep(shift);
        }

    }
    const [ispiEmailValid, setIsPiEmailValid] = useState(true)
    const handleBlur = (e) => {
        const {name, value} = e.target;
        if (name === 'piOtherEmail') {
            if(value ===''){
                setIsEmailValid(true)
            }else
            setIsEmailValid(validateEmail(piOtherEmail));
        }
        // if (e.target.name === 'piEmail') {
        //     setIsPiEmailValid(validateEmail(piEmail));
        // }
else(setIsPiEmailValid(false))

    };
    const [isEmailValid, setIsEmailValid] = useState(true);
    const validateEmail = (email) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        return regex.test(email);
    };

    function convertToTitleCase(str) {
        return str.replace(/\w\S*/g, function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }
    const customDropdownIndicator = () => null;

    return (
        <>
        <div>
            <NavigationBar studyDropdwn={true} title={"Principal Investigator"} />
            <div className='main_body registration_steps_main '>
                <div className='row flex-nowrap'>
                    <div className="col-lg-3 col pi_left_content_main" >
                        <div className='lableSteps'>
                            <span >Registration Steps</span>
                        </div>

                        <div className='pmsaddpireg'>
                            {registrationSteps?.map((step, index) => {
                                return (
                                    <div
                  key={index}
                    className={`${
                      regStep === index + 1 ? "selectedTabStyl" : ""
                    }`}
                  >
                                    <div className={`my-div ${regStep === index + 1 ? 'registration_steps_selected' : 'registration_steps'}`} key={index}>
                                        <span>{step.stepTitle}</span>
                                        <span className='registration_description'>{step.description}</span>
                                    </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className="col">
                        <div className='lableContent'>
                            <span >{registrationSteps[regStep - 1].stepTitle}</span>
                            <span >{regStep} of 4</span>
                        </div>

                        {/* PI Details inputs */}
                        {regStep === 1 &&
                            <div style={{ height: "68vh", overflowY: "auto", background: "white", marginBottom: "70px" }}>
                                <div className='piDetilsRow'>
                                    <div className='piDetilsItems'>
                                        <label htmlFor="piName">PI Name<span style={{ color: "red" }}>*</span></label>
                                        <input
                                            value={piName}
                                            className="customInput"
                                            id='piName'
                                            type='text'
                                            placeholder='Full Name'
                                            aria-placeholder='#D4D4D4'
                                            style={{ padding: "16px 12px" }}
                                            onChange={handlePiNameChange}
                                        />
                                    </div>
                                     <div className='piDetilsItems'>
                                      <label htmlFor="piContactNumber">PI Contact Number<span style={{ color: "red" }}>*</span></label>
                                                    <div className='d-flex'>
                                                        <input
                                                        value={"+91"}
                                                        className="country_code"
                                                        placeholder="+91"
                                                        aria-placeholder="#D4D4D4"
                                                        style={{
                                                            width: "50px",
                                                            borderRadius: "8px 0px 0px 8px",
                                                            backgroundColor: "#F7F9FB",
                                                            boxSizing: "border-box", // Adjust box-sizing
                                                            padding: "16px 7px", // Adjust padding to fit content
                                                        }}
                                                        disabled
                                                        />
                                                        <input
                                                        className="customInput noSpinArrows phn_input"
                                                        value={piContactNumber}
                                                        id='piContactNumber'
                                                        type='number'
                                                        placeholder='9922112233'
                                                        maxLength={10}
                                                        aria-placeholder='#D4D4D4'
                                                        style={{
                                                            width: "180px", // Set the width of the second input
                                                            borderRadius: "0px 8px 8px 0px",
                                                            padding: "16px 12px", // Adjust padding to fit content
                                                        }}
                                                        onChange={handlePiContactNumberChange}
                                                        min="0"
                                                        />
                                                    </div>
                                                    {phoneSatisfied && <p className='errormsg'>* Must be 10 digits</p>}
                                                    </div>

                                    <div className='piDetilsItems '>
                                        <label htmlFor="piEmail">PI Email<span style={{ color: "red" }}>*</span></label>
                                        <input
                                            className="customInput"
                                            value={piEmail}
                                            id='piEmail'
                                            type='email'
                                            name='piEmail'
                                            placeholder='email@gmail.com'
                                            aria-placeholder='#D4D4D4'
                                            style={{ padding: "16px 12px" }}
                                            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                                            required
                                            onChange={handlePiEmailChange}
                                        />
                                        {!ispiEmailValid && <p className='errormsg' >Invalid email format</p>}
                                    </div>
                                </div>
                                <div className='piDetilsRow'>
                                    <div className='piDetilsItems'>
                                        <div className='piDetilsItems pt-0'>
                                            <label htmlFor="qrGender">Sex<span style={{ color: "red" }}>*</span></label>
                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", }}>
                                                <button onClick={() => handlePiGenderChange("Male")} className={`${(piGender === "Male") ? "PigenderBtnSelected" : "PigenderButton"}`} style={{ borderRadius: "6px 0px 0px 6px" }}>Male</button>
                                                <button onClick={() => handlePiGenderChange("Female")} className={`${(piGender === "Female") ? "PigenderBtnSelected" : "PigenderButton"}`}>Female</button>
                                                <button onClick={() => handlePiGenderChange("Others")} className={`${(piGender === "Others") ? "PigenderBtnSelected" : "PigenderButton"}`} style={{ borderRadius: "0px 6px 6px 0px" }}>Others</button>
                                            </div>

                                        </div>

                                    </div>
                                    <div className='piDetilsItems'>
                                        <label htmlFor="piAddressLane1">Address Line 1<span style={{ color: "red" }}>*</span></label>
                                        <input
                                            className="customInput"
                                            value={piAddressLane1}
                                            id='piAddressLane1'
                                            type='text'
                                            placeholder='Kaveri Hills'
                                            aria-placeholder='#D4D4D4'
                                            style={{ padding: "16px 12px" }}
                                            onChange={handlePiAddressLane1Change}
                                        />
                                    </div>
                                    <div className='piDetilsItems'>
                                        <label htmlFor="piCountry">Country<span style={{ color: "red" }}>*</span></label>
                                        <input
                                            className="customInput"
                                            value={piCountry}
                                            id='piCountry'
                                            type='text'
                                            placeholder='India'
                                            aria-placeholder='#D4D4D4'
                                            style={{ padding: "16px 12px" }}
                                            onChange={handlePiCountryChange}
                                        />
                                    </div>
                                </div>
                                <div className='piDetilsRow'>
                                    <div className='piDetilsItems'>
                                        <label htmlFor="piState">State<span style={{ color: "red" }}>*</span></label>
                                        <input
                                            className="customInput"
                                            value={piState}
                                            id='piState'
                                            type='text'
                                            placeholder='Telangana'
                                            aria-placeholder='#D4D4D4'
                                            style={{ padding: "16px 12px" }}
                                            onChange={handlePiStateChange}
                                        />
                                    </div>
                                    <div className='piDetilsItems'>
                                        <label htmlFor="piDistrict">District<span style={{ color: "red" }}>*</span></label>
                                        <input
                                            className="customInput"
                                            value={piDistrict}
                                            id='piDistrict'
                                            type='text'
                                            placeholder='Hyderabad'
                                            aria-placeholder='#D4D4D4'
                                            style={{ padding: "16px 12px" }}
                                            onChange={handlePiDistrictChange}
                                        />
                                    </div>
                                    <div className='piDetilsItems'>
                                        <label htmlFor="piCity">City<span style={{ color: "red" }}>*</span></label>
                                        <input
                                            className="customInput"
                                            value={piCity}
                                            id='piCity'
                                            type='text'
                                            placeholder='Hyderabad'
                                            aria-placeholder='#D4D4D4'
                                            style={{ padding: "16px 12px" }}
                                            onChange={handlePiCityChange}
                                        />
                                    </div>
                                </div>
                                <div className='piDetilsRow'>
                                    <div className='piDetilsItems'>
                                        <label htmlFor="piPincode">Pincode<span style={{ color: "red" }}>*</span></label>
                                        <input
                                            className="customInput noSpinArrows"
                                            value={ piPincode}
                                            id='piPincode'
                                            type='number'
                                            maxLength={6}
                                            placeholder='500081'
                                            aria-placeholder='#D4D4D4'
                                            style={{ padding: "16px 12px" }}
                                            onChange={handlePiPincodeChange}
                                        />
                                        {pincodeSatisfied &&
                                            <p className='errormsg'>* Must be 6 digits </p>}
                                    </div>
                                    <div className='piDetilsItems'>
                                        <label htmlFor="piNationality">Nationality<span style={{ color: "red" }}>*</span></label>
                                        <input
                                            className="customInput"
                                            value={piNationality}
                                            id='piNationality'
                                            type='text'
                                            placeholder='Indian'
                                            aria-placeholder='#D4D4D4'
                                            style={{ padding: "16px 12px" }}
                                            onChange={handlePiNationalityChange}
                                        />
                                    </div>
                                    <div className='piDetilsItems'>
                                        <label htmlFor="piAadhar">Aadhar Card Number<span style={{ color: "red" }}>*</span></label>
                                        <input
                                            className="customInput"
                                            value={piAadhar.length === 12 ? maskedAadhar : piAadhar}
                                            id='piAadhar'
                                            type='text'
                                            maxLength={12}
                                            placeholder='1234 5678 9012'
                                            aria-placeholder='#D4D4D4'
                                            style={{ padding: "16px 12px" }}
                                            onChange={handlePiAadharChange}
                                        />
                                        {aadharSatisfied &&
                                            <p className='errormsg'>* Must be 12 digits </p>}
                                    </div>
                                </div>
                                <div className='piDetilsRow'>
                                    <div className='piDetilsItems'>
                                        <label htmlFor="piIdType">ID Proof Type</label>
                                        <input
                                            className="customInput"
                                            value={piIdType}
                                            id='piIdType'
                                            type='text'
                                            placeholder='PAN'
                                            aria-placeholder='#D4D4D4'
                                            style={{ padding: "16px 12px" }}
                                            onChange={handlePiIdTypeChange}
                                        />
                                    </div>
                                    <div className='piDetilsItems'>
                                        <label htmlFor="piIdNumber">ID Proof Number</label>
                                        <input
                                            className="customInput"
                                            value={piIdNumber}
                                            id='piIdNumber'
                                            type='text'
                                            placeholder='BQCTE3548F'
                                            aria-placeholder='#D4D4D4'
                                            style={{ padding: "16px 12px" }}
                                            onChange={handlePiIdNumberChange}
                                        />
                                    </div>
                                    <div className='piDetilsItems'>
                                        <label htmlFor="piOtherEmail">Other Email Address</label>
                                        <input
                                            className="customInput"
                                            value={piOtherEmail}
                                            id='piOtherEmail'
                                            type='email'
                                            name='piOtherEmail'
                                            placeholder='email@gmail.com'
                                            aria-placeholder='#D4D4D4'
                                            style={{ padding: "16px 12px" }}
                                            onChange={handlePiOtherEmailChange}
                                            onBlur={handleBlur}
                                        />
                                        {!isEmailValid && <p className='errormsg' style={{ color: 'red' }}>Invalid email format</p>}
                                    </div>
                                </div>

                                <div className='piDetilsRow'>
                                    <div className='piDetilsItems' >
                                        <label htmlFor="piMciNumber">MCI Registration Number<span style={{ color: "red" }}>*</span></label>
                                        <input
                                            className="customInput"
                                            value={piMciNumber}
                                            id='piMciNumber'
                                            type='text'
                                            placeholder='650001'
                                            aria-placeholder='#D4D4D4'
                                            style={{ padding: "16px 12px" }}
                                            onChange={handlePiMciNumberChange}
                                        />
                                    </div>
                                    <div className='piDetilsItems'  style={{marginRight:"5px"}}>
                                        <label htmlFor="piNMciDate">MCI Registration Date<span style={{ color: "red" }}>*</span></label>
                                        <input
                                            className="customInput"
                                            value={piNMciDate}
                                            id='piNMciDate'
                                            type='date'

                                            aria-placeholder='#D4D4D4'
                                            style={{ padding: "16px 12px" ,cursor: "not-allowed"}}
                                            onChange={handlePiNMciDateChange}
                                            max={new Date().toISOString().slice(0, 10)}
                                            onKeyDown={(e) => e.preventDefault()}
                                        />
                                    </div>
                                 
                                    <div className='piDetilsItems mb-3'  style={{marginRight:"30px" }}>
                                        <label htmlFor="piAadhar">Resume Upload ({"<"}20MB)<span style={{ color: "red" }}>*</span></label>
                                        <input
                                            ref={fileInputRef}
                                            style={{ display: 'none' }}
                                            id='piAadhar'
                                            type='file'
                                            onChange={handleChangeFileUpload}
                                        />
                                        {/* Display any information about the selected file if needed */}
                                        {resumeName && (
                                            <div style={{ display: 'flex', alignItems: 'center'}}>
                                                <span style={{ color: "green", marginTop: "5px", marginRight: "5px" }} title={resumeName}>{resumeName.length > 10 ? resumeName.slice(0, 15) + "..." : resumeName}</span>
                                                <span style={{ cursor: 'pointer', fontSize: '1.0rem' }} title="Click on this icon to preview your uploaded file" onClick={handlePreview}>📄</span>
                                                
                                                <span style={{ cursor: 'pointer', color: 'red', fontSize: '2.3rem',marginTop:"2px" ,marginLeft:"3px"}} title='Click on this to delete the file' onClick={handleClearFile}>&times;</span>
                                            </div>
                                        )}
                                        {!resumeName && (
                                           <div style={{ display: 'flex', flexDirection: 'column',marginRight:"-50px"   }} >
                                            <button className="customButton" onClick={handleButtonClick} style={{ border: '1px solid grey', height: '40px', width: '200px' }}>
                                                Choose File
                                            </button>
                                            <span className='mt-1'>(jpg, jpeg, png, pdf, doc, docx)</span>
                                            </div>
                                        )
                                       
                                    }
                                    </div>
                                </div>

                            </div>
                        }
                        {/* Study and Dose Details */}
                        {regStep === 2 && 
                        <div className='piRegPrev'>
                            <div  style={{ margin: '32px', display:"flex", flexDirection:"column", textAlign:"start" }}>
                                <label htmlFor="piStudy">Select Study<span style={{color:"red"}}>*</span></label>
                               
                                <Select
                                    id="piStudy"
                                    isMulti
                                    options={studyData?.map((item) => ({
                                        value: item,
                                        label: `${item.study_name}`,
                                      }))}
                                    value={selectedOptions}
                                    onChange={handleChange}
                                    className='custom_select_main'
                                    placeholder="Select Study from the options"
                                    styles={{
                                        control: (provided, state) => ({
                                          ...provided,
                                         margin: 'auto',
                                          paddingRight:"25px" 
                                        }),
                                       }}
                                   components={{
                                        IndicatorSeparator: () => null, 
                                     DropdownIndicator: customDropdownIndicator,
                                     ClearIndicator: () => null,
                                        
                                 }}
                                />
                                </div>
                               
                        </div>
                        }
                        {/* Site Information */}
                        {regStep === 3 && 
                        <div className='piRegPrev'>
                            <div className='siteInformationRows'>
                                <div className='siteInformationItems'>
                                    <label htmlFor="piStudy">Select Zone<span style={{color:"red"}}>*</span></label>
                                    <div className='custom_select_main'>
                                    <select id='piStudy' className='custom-select ' value={zone} style={{width:"380px"}} onChange={selectZone}>
                                        <option value={''}>Please select Zone</option>
                                        {zoneData && zoneData?.map((zone) => 
                                            <option value={zone.zone_id}>{zone.zone_name}</option>
                                        )}
                                        
                                    </select>
                                    </div>
                                </div>
                                <div className='siteInformationItems'>
                                    <label htmlFor="piStudy">Select State<span style={{color:"red"}}>*</span></label>
                                    <div className='custom_select_main'>
                                    <select id='piStudy' className='custom-select' value={stateSelected} style={{width:"380px"}} onChange={selectState}>
                                        <option value={''}>Please select state</option>
                                        {stateData && stateData?.map((states) => 
                                            <option value={states.state_id}>{states.state_name}</option>
                                        )}
                                    </select>
                                    </div>
                                </div>
                            </div>

                            <div className='siteInformationRows'>
                                <div className='siteInformationItems'>
                                    <label htmlFor="piStudy">Select City<span style={{color:"red"}}>*</span></label>
                                    <div className='custom_select_main'>
                                    <select id='piStudy' className='custom-select' value={city} style={{width:"380px"}} onChange={selectCity}>
                                        <option value={''}>Please select City</option>
                                        {cityData && cityData?.map((cities) => 
                                            <option value={cities.city_id}>{cities.city_name}</option>
                                        )}
                                    </select>
                                    </div>
                                </div>
                                <div className='siteInformationItems'>
                                    <label htmlFor="piStudy">Select Site<span style={{color:"red"}}>*</span></label>
                                    <div className='custom_select_main'>
                                    <select id='piStudy' className='custom-select' value={site} style={{width:"380px"}} onChange={selectSite}>
                                        <option value={''}>Please select site</option>
                                        {siteData && siteData?.map((sites) => 
                                            <option value={sites.site_id}>{sites.site_name}</option>
                                        )}
                                    </select>
                                    </div>
                                </div>
                            </div>

                            <div className=' siteInformationRows '>
                                <div className='siteInformationItems'>
                                    <label htmlFor="piStudy">Site Code</label>
                                    <input
                                        value={siteCode}
                                        id='piName'
                                        type='text'
                                        placeholder='Site code'
                                        aria-placeholder='#D4D4D4'
                                        style={{padding:"16px 12px", width:"380px"}}
                                        disabled
                                    />
                                </div>
                                
                                 <div className='siteInformationItems'>
                                 <label htmlFor="piStudy">Site Address</label>
                                 <p className={`multiline-text ${siteAddress ? '' : 'placeholder-text'}`}>
                                        {siteAddress || 'Site Address'}
                                    </p>

                                </div>
                           
                                   

                      
                            </div>
                            
                            </div>
                        }
                        {/* Site Information */}
                         
                        {regStep === 4 &&
                            <div className='piRegPrev'>
                                <div style={{ margin: "24px 32px" }}>
                                    <p style={{ fontWeight: "bold", color: "black" }}>Name: {piName}</p>

                                </div>
                                <div style={{ border: "1px dotted #E1E5E7", marginLeft: "32px", marginRight: "24px" }}></div>
                                <div style={{ display: "flex", flexDirection: "row", margin: "24px 32px 0px 32px", justifyContent: "space-evenly" }}>
                                    <p>
                                        +91 {piContactNumber}
                                        <img style={{ height: "20px", margin: "6px", paddingLeft: "5px" }} src="./images/icons/Phone Telephone by Streamlinehq (1).svg" alt="" />

                                    </p>
                                    <p>.</p>
                                    <p>
                                        {piEmail}
                                        <img style={{ height: "20px", margin: "5px" }} src="./images/icons/Mail Send Envelope by Streamlinehqmainemail.svg" alt="" />
                                    </p>
                                    <p>.</p>
                                    <p>Aadhar: { "*".repeat(piAadhar.length - 4) + piAadhar.slice(-4)}</p>

                                </div>

                                <div style={{ border: "1px dotted #E1E5E7", marginLeft: "32px", marginRight: "32px" }}></div>
                                <div style={{ margin: "14px 22px 0px 22px", backgroundColor: "#EAEAEA", borderRadius: "8px", padding: "10px" }}>
                                    <p style={{ padding: "20px 20px 10px 20px", color: "black", fontWeight: "bold" }}>{siteName}</p>
                                    <div style={{ border: "1px dotted #E1E5E7" }}></div>
                                    <div style={{ display: 'flex', flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                        <div style={{ margin: "24px" }}>
                                            <p>Site code: {siteCode}</p>
                                            <p>{cityName},  {stateName}, {zoneName}</p>
                                            <p>{piContactNumber}</p>
                                        </div>
                                        <div>
                                            <img style={{ height: "20px", margin: "6px", paddingLeft: "5px" }} src="./images/icons/Travel Map Location Pin by Streamlinehq.svg" alt="" />

                                        </div>

                                    </div>

                                </div>
                                {selectedOptions &&

                                    selectedOptions?.map((item) => 
                                    
                                    (
                                        <div style={{ margin: "14px 22px 0px 22px", backgroundColor: "#EAEAEA", borderRadius: "8px", padding: "10px" }}>
                                        <p style={{ padding: "20px 20px 10px 20px", color: "black", fontWeight: "bold" }}>{item.value.product_name}</p>
                                        <div style={{ border: "1px dotted #E1E5E7" }}></div>
                                        <div className="d-flex ms-3">
                                            <div className="col-3">
                                            <p>Study Name</p>
                                            </div>
                                            <div className="col-9">
                                            <p style={{ color: "black", fontWeight: "bold" }}>{item.value.study_name}</p>
                                            </div>
                                        </div>
                                        <div className="d-flex ms-3">
                                            <div className="col-3">
                                            <p>Number of Doses</p>
                                            </div>
                                            <div className="col-9">
                                            <p style={{ color: "black", fontWeight: "bold" }}>{item.value.number_of_doses}</p>
                                            </div>
                                        </div>
                                        <div className="d-flex ms-3">
                                            <div className="col-3">
                                            <p>Duration Between Doses</p>
                                            </div>
                                            <div className="col-9">
                                            <p style={{ color: "black", fontWeight: "bold" }}>{item.value.duration_between_doses} {item.value.duration_between_doses_type}</p>
                                            </div>
                                        </div>
                                        <div className="d-flex ms-3">
                                            <div className="col-3">
                                            <p>Dose of Administration</p>
                                            </div>
                                            <div className="col-9">
                                            <p style={{ color: "black", fontWeight: "bold" }}>{item.value.dose_of_administration}</p>
                                            </div>
                                        </div>
                                        <div className="d-flex ms-3">
                                            <div className="col-3">
                                            <p>Age Group</p>
                                            </div>
                                            <div className="col-9">
                                            <p style={{ color: "black", fontWeight: "bold" }}>{item.value.age_group}</p>
                                            </div>
                                        </div>
                                    </div>
                                    )
                                    )}

                                <div style={{ margin: "14px 22px 0px 22px", backgroundColor: "#EAEAEA", borderRadius: "8px", padding: "10px" }}>
                                    <p style={{ padding: "20px 20px 10px 20px" }}><b>Principal Investigator Other Details</b></p>
                                    <div style={{ border: "1px dotted #E1E5E7" }}></div>
                                    <div style={{ margin: "20px" }}>
                                        <p>Address: {piAddressLane1}, {piCity}, {piDistrict}, {piState}, {piCountry}, {piPincode}</p>
                                        <p>MCI Number: {piMciNumber}</p>
                                        <p>MCI Date: {piNMciDate}</p>
                                    </div>
                                </div>
                            </div>

                        }



                        <div className='registrationStepsFooter'>
                            {regStep === 1 &&
                                <button className="white_btn px-4" onClick={() => navigate('/pilist')} >Cancel</button>
                            }
                            {regStep > 1 &&
                                <button className="white_btn" onClick={() => handleStepChange(-1)} >Previous</button>
                            }
                            {regStep === 1 &&
                                <button className="orange_btn" onClick={() => handleStepChange(1)}
                                    disabled={!(piName !== "" && piContactNumber !== "" && piEmail !== ""
                                        && piGender !== "" && piAddressLane1 !== "" &&
                                        piCountry !== "" && piState !== "" && piDistrict !== ""
                                        && piCity !== "" && piPincode !== "" &&
                                        piNationality !== "" && piAadhar !== "" &&
                                        piMciNumber !== "" && piNMciDate !== "" &&
                                        resume !== "" && resume != undefined &&
                                        phoneSatisfied === false && aadharSatisfied === false &&
                                        pincodeSatisfied === false && ispiEmailValid)}
                                >Continue</button>
                            }
                            {regStep === 2 &&
                                <button
                                    disabled={selectedOptions.length === 0}
                                    className="orange_btn" onClick={() => handleStepChange(1)}>Continue</button>
                            }
                            {regStep === 3 &&
                                <button className="orange_btn" onClick={() => handleStepChange(1)}
                                    disabled={!(zone !== "" &&
                                        stateSelected !== "" && city !== "" && site !== "")}
                                >Continue</button>

                            }
                            {regStep === 4 &&
                                <button className="orange_btn" disabled={diable} onClick={createNewPI}>Done</button>
                            }
                        </div>

                    </div>
                </div>

            </div>
            <PopUpModal
                handleClose={handleClosePopup}
                open={open}
                title={"Success!"}
                msg={convertToTitleCase(piName)+ "'s Principal Investigator profile has been created!"}
                close={"Done"}
                actionbtn={"Done"}
                onConfirm={viewProfile}
            />
        </div>
        {loading && <Loader />}
        </>
    );
};

export default PMSAdminAddPI;   